<template>
  <footer class="foot">
    <div class="foot-row">
      <p class="foot-copy">© CHARIBON BY VALUE BOOKS ALL RIGHTS RESERVED.</p>
      <dl class="foot-ssl">
        <dt class="foot-ssl__icn"><img :src="`${cdnBaseUrl}/charibon/images/common/img_ssl.jpg`" alt="グローバルサイン認証サイト"></dt>
        <dd class="foot-ssl__text">
          <p>当サイトは、プライバシー保護のため、グローバルサインのSSLサーバ証明書を使用し、SSL暗号化通信を実現しています。<br>SSL技術により暗号化されるため、お客様にご記入頂いた内容は安全に送信されます。
          </p>
        </dd>
      </dl>
    </div>
  </footer>
</template>

<script>
export default {
  name: "charibon-footer",
  data() {
    return {
      cdnBaseUrl: VueConfig.cdn_url.replace("/ws/site", "")
    }
  },
}
</script>

<style scoped>
* {
    font-family: "メイリオ", Meiryo, "游ゴシック", "Yu Gothic", YuGothic, "Hiragino Kaku Gothic ProN", "Hiragino Kaku Gothic Pro", "ＭＳ ゴシック", sans-serif !important;
}

ul {
  list-style: none;
}

a {
  text-decoration: none;
  outline: none;
}

.foot {
  width: 100%;
  text-align: center;
}

.foot-row {
  /*min-width: 1080px;*/
}

.foot-copy {
  font-size: 11px;
  /*font-size: 1.1rem;*/
}

.foot-ssl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-width: 670px;
  margin: 0 auto;
  padding: 20px 0;
}

.foot-ssl__text {
  padding: 0 0 0 15px;
  text-align: left;
}
.foot-ssl__text p {
  font-size: 10px;
  /*font-size: 1rem;*/
}

@media screen and (max-width: 767px) {

  .foot {
    width: 100%;
    text-align: center;
  }

  .foot-row {
    min-width: 100%;
    max-width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .foot-copy {
    text-align: center;
    padding: 0 3%;
  }

  .foot-ssl {
    padding: 30px 3% 90px;
  }

  .foot-ssl__icn {
    width: 90px;
  }

  .foot-ssl__text {
    width: calc(100% - 90px);
    padding: 0 0 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .foot-ssl__text p {
    font-size: 10px;
    /*font-size: 1rem;*/
  }
}
</style>